/**
 * Read-only renderer for stored rich_description content.
 *
 * The customer PWA never edits rich text — it only re-hydrates a stored,
 * already-valid serialized editor state (see App.tsx, editable:false) and
 * displays it. Node classes render themselves via createDOM()/decorate(), so
 * no editing plugins, toolbar, commands or transforms are required to display
 * existing content. This replaces the full vendored playground <Editor/> on
 * the customer render path.
 *
 * The wrapper markup/classes below intentionally mirror the old Editor.tsx
 * return so styling is unchanged.
 */

import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import * as React from 'react';

import ContentEditable from './ui/ContentEditable';

export default function ReadOnlyEditor(): JSX.Element {
  return (
    <div className="editor-shell mx-4 bg-surface-variant">
      <div className="editor-container bg-surface-variant">
        <RichTextPlugin
          contentEditable={
            <div className="shadow-md mt-8 rounded-md bg-surface-variant">
              <div className="editor bg-surface-variant">
                <ContentEditable placeholder="" />
              </div>
            </div>
          }
          ErrorBoundary={LexicalErrorBoundary}
        />
      </div>
    </div>
  );
}
